var _defs, _path;
const _excluded = ["title", "titleId"];
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
function _objectWithoutProperties(e, t) { if (null == e) return {}; var o, r, i = _objectWithoutPropertiesLoose(e, t); if (Object.getOwnPropertySymbols) { var n = Object.getOwnPropertySymbols(e); for (r = 0; r < n.length; r++) o = n[r], -1 === t.indexOf(o) && {}.propertyIsEnumerable.call(e, o) && (i[o] = e[o]); } return i; }
function _objectWithoutPropertiesLoose(r, e) { if (null == r) return {}; var t = {}; for (var n in r) if ({}.hasOwnProperty.call(r, n)) { if (-1 !== e.indexOf(n)) continue; t[n] = r[n]; } return t; }
import * as React from "react";
function SvgAisLogo(_ref, svgRef) {
  let {
      title,
      titleId
    } = _ref,
    props = _objectWithoutProperties(_ref, _excluded);
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 145,
    height: 67,
    id: "Ebene_1",
    "data-name": "Ebene 1",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    viewBox: "0 0 1082.13 505.8",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("linearGradient", {
    id: "Unbenannter_Verlauf_28",
    "data-name": "Unbenannter Verlauf 28",
    x1: 0,
    y1: 252.9,
    x2: 1082.13,
    y2: 252.9,
    gradientUnits: "userSpaceOnUse"
  }, /*#__PURE__*/React.createElement("stop", {
    offset: 0,
    stopColor: "#e31937"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.11,
    stopColor: "#cb1d49"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.25,
    stopColor: "#a62566"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.41,
    stopColor: "#a22568"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.53,
    stopColor: "#992770"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.64,
    stopColor: "#882a7d"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.75,
    stopColor: "#712f90"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.84,
    stopColor: "#5435a9"
  }), /*#__PURE__*/React.createElement("stop", {
    offset: 0.85,
    stopColor: "#5236ab"
  })))), _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M499.79,9.01h129.08v487.79h-129.08V9.01ZM148.59,9.01h156.09l148.59,487.79h-136.58l-24.01-103.56h-136.58l-24.01,103.56H0L148.59,9.01ZM179.36,293.42h90.05l-8.26-33.77c-12.01-46.53-24.01-105.81-36.02-154.59h-3c-10.51,49.53-22.51,108.06-34.52,154.59l-8.26,33.77ZM706.91,436.01l73.54-88.55c34.52,27.77,78.05,47.28,114.07,47.28,39.02,0,55.53-12.76,55.53-34.52,0-23.26-24.77-30.77-66.04-47.28l-60.79-25.51c-52.53-21.01-98.31-65.29-98.31-135.83C724.92,68.29,799.97,0,906.53,0c55.53,0,117.07,21.01,162.1,65.29l-64.54,81.05c-33.02-23.26-61.54-35.27-97.56-35.27-31.52,0-51.03,11.26-51.03,33.02,0,23.27,27.77,31.52,72.04,48.78l59.29,23.26c60.79,24.01,95.31,66.04,95.31,133.58,0,82.55-69.04,156.09-190.61,156.09-61.54,0-132.08-22.51-184.61-69.79Z",
    fill: "url(#Unbenannter_Verlauf_28)"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgAisLogo);
export default __webpack_public_path__ + "static/media/AIS-Logo.a1da1918f8925197160a73d24ba12c5e.svg";
export { ForwardRef as ReactComponent };